import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionDirective } from 'src/app/directives/accordion.directive';
import { HEWBatchStockDTO } from 'src/app/models/types/Product/Stock.type';
import { SharedModule } from 'src/app/modules/shared.module';

@Component({
  selector: 'app-hew-stock',
  imports: [
    AccordionDirective,
    SharedModule
  ],
  templateUrl: './hew-stock.component.html',
  styleUrl: './hew-stock.component.scss'
})
export class HewStockComponent {

  @Input('hewStock') hewStock!: HEWBatchStockDTO;

}
